import { useEffect, useRef, useState } from "react";

const MIN_SPINNER_MS = 500;

/**
 * Starts the spinner on press rather than on `isPending`: native hosts take the
 * share over without a web request, so `isPending` never turns true there.
 */
export function useShareSpinner(isPending: boolean) {
    const holdTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [isHolding, setIsHolding] = useState(false);

    useEffect(function clearHoldTimerOnUnmount() {
        return () => {
            clearHoldTimer(holdTimerRef);
        };
    }, []);

    function startSpinner() {
        clearHoldTimer(holdTimerRef);
        setIsHolding(true);
        holdTimerRef.current = setTimeout(() => {
            holdTimerRef.current = null;
            setIsHolding(false);
        }, MIN_SPINNER_MS);
    }

    return { showSpinner: isPending || isHolding, startSpinner };
}

function clearHoldTimer(timerRef: { current: ReturnType<typeof setTimeout> | null }) {
    if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
    }
}
